import { render, staticRenderFns } from "./DejavooPartialApprovalModal.vue?vue&type=template&id=95fb632a&scoped=true"
import script from "./DejavooPartialApprovalModal.vue?vue&type=script&lang=js"
export * from "./DejavooPartialApprovalModal.vue?vue&type=script&lang=js"
import style0 from "./DejavooPartialApprovalModal.vue?vue&type=style&index=0&id=95fb632a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95fb632a",
  null
  
)

export default component.exports